var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("b-overlay", { attrs: { show: _vm.isLoading, rounded: "sm" } }, [
    _vm.isLoading
      ? _c("div", { staticClass: "my-5" })
      : !_vm.items.length && !_vm.isLoading
      ? _c(
          "div",
          { staticClass: "text-center my-5" },
          [
            _c("b-icon", {
              attrs: {
                icon: "exclamation-circle-fill",
                variant: "danger",
                "font-scale": "2",
              },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "mt-2" }, [_vm._v("No items found")]),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "list-group" },
          _vm._l(_vm.items, function (item, index) {
            return _c(_setup.ModalImportListItem, {
              key: index + "-item",
              attrs: { item: item },
              on: { "item-selected": _setup.itemSelected },
            })
          }),
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }